module.exports = __webpack_public_path__ + "img/bus_sidebar_img_2.216762e8.svg";